import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[zefSidenavButtonSecondary]',
  standalone: false,
})
export class SidenavButtonSecondary {
  readonly tr = inject<TemplateRef<any>>(TemplateRef);
}
